const normalizeBase = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';

  if (typeof window !== 'undefined') {
    if (raw.startsWith(':')) {
      return `${window.location.protocol}//${window.location.hostname}${raw}`.replace(/\/+$/, '');
    }
    if (raw.startsWith('//')) {
      return `${window.location.protocol}${raw}`.replace(/\/+$/, '');
    }
    if (raw.startsWith('/')) {
      return `${window.location.origin}${raw}`.replace(/\/+$/, '');
    }
  }

  return raw.replace(/\/+$/, '');
};

const computeApiBase = () => {
  const envBase =
    (typeof process !== 'undefined' && process.env && (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL)) ||
    (typeof window !== 'undefined' && window.__API_BASE__) ||
    '';

  if (envBase) {
    return normalizeBase(envBase.replace(/\/api\/?$/, ''));
  }

  if (typeof window !== 'undefined') {
    const { protocol, host, hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:8000';
    }
    return `${protocol}//${host}`;
  }

  return 'http://localhost:8000';
};

const API_BASE = computeApiBase();

if (typeof window !== 'undefined') {
  window.__API_BASE__ = normalizeBase(window.__API_BASE__ || API_BASE) || API_BASE;
}

const rewriteLocalBackendUrl = (url) => {
  if (typeof url !== 'string') return url;

  // Recover malformed runtime URLs such as ":8000/api/..."
  if (typeof window !== 'undefined' && url.startsWith(':')) {
    return `${window.location.protocol}//${window.location.hostname}${url}`;
  }

  if (url.startsWith('http://localhost:8000')) {
    return API_BASE + url.slice('http://localhost:8000'.length);
  }
  if (url.startsWith('http://127.0.0.1:8000')) {
    return API_BASE + url.slice('http://127.0.0.1:8000'.length);
  }
  return url;
};

if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    if (typeof input === 'string') {
      return originalFetch(rewriteLocalBackendUrl(input), init);
    }
    if (typeof Request !== 'undefined' && input instanceof Request) {
      const nextUrl = rewriteLocalBackendUrl(input.url);
      if (nextUrl !== input.url) {
        const nextRequest = new Request(nextUrl, input);
        return originalFetch(nextRequest, init);
      }
    }
    return originalFetch(input, init);
  };
}

if (typeof window !== 'undefined' && typeof window.XMLHttpRequest !== 'undefined') {
  const originalOpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function patchedOpen(method, url, async, user, password) {
    const nextUrl = typeof url === 'string' ? rewriteLocalBackendUrl(url) : url;
    return originalOpen.call(this, method, nextUrl, async, user, password);
  };
}

if (typeof window !== 'undefined' && typeof window.EventSource !== 'undefined') {
  const NativeEventSource = window.EventSource;
  const PatchedEventSource = function patchedEventSource(url, config) {
    const nextUrl = typeof url === 'string' ? rewriteLocalBackendUrl(url) : url;
    return new NativeEventSource(nextUrl, config);
  };
  PatchedEventSource.prototype = NativeEventSource.prototype;
  window.EventSource = PatchedEventSource;
}

// Safely protect against Chromium / React 19 dev-mode DataCloneError in performance.measure
if (typeof window !== 'undefined' && window.performance && typeof window.performance.measure === 'function') {
  const nativeMeasure = window.performance.measure.bind(window.performance);
  window.performance.measure = function safeMeasure(name, startOrOptions, end) {
    try {
      return nativeMeasure(name, startOrOptions, end);
    } catch (err) {
      // If structuredClone failed on detail or out-of-memory, retry without detail or suppress gracefully
      if (startOrOptions && typeof startOrOptions === 'object') {
        try {
          const { detail, ...safeOptions } = startOrOptions;
          return nativeMeasure(name, safeOptions, end);
        } catch {
          return undefined;
        }
      }
      return undefined;
    }
  };
}

export { API_BASE, rewriteLocalBackendUrl };
